import ErrorCodeHelper from '@dealroadshow/error-codes';
import { getMessageByErrorCode } from '@framework/message/Mapper/getMessage';
import DmPortalUserRepository from '@dm-portal/user/UserRepository';
import UserRepository from '@users/user/UserRepository';
import { AlertManager } from '@dealroadshow/uikit-alert';
import Container from '@framework/di/Container';
/**
 * Resend verification email
 *
 * @param {Container} container
 * @param {String} email
 * @param {?String} entryCode
 * @param {?String} roadshowId
 *
 * @returns {Promise<void>}
 */
export async function resendVerificationEmail(
  container: Container,
  { email, entryCode = null, roadshowId = null }: { email: string, entryCode?: string | null, roadshowId?: number | null },
) {
  const dmPortalUserRepository: DmPortalUserRepository = container.get(DmPortalUserRepository);
  await dmPortalUserRepository.resendVerificationEmail({ email, entryCode, roadshowId });

  AlertManager.info(getMessageByErrorCode(ErrorCodeHelper.getCodeByName('INVESTOR_VERIFICATION_EMAIL_SENT'), { email }));
}

/**
 * Resend activation email
 *
 * @param {Container} container
 * @param {string} email
 * @param {string} callbackUrl
 * @param {string} tenant
 *
 * @returns {Promise<void>}
 */
export async function resendActivationEmail(
  container: Container,
  { email, callbackUrl, tenant }: { email: string, callbackUrl: string, tenant: string },
) {
  const userRepository: UserRepository = container.get(UserRepository);
  await userRepository.resendActivationEmail({ email, callbackUrl, tenant });

  AlertManager.info(getMessageByErrorCode(ErrorCodeHelper.getCodeByName('USER_ACTIVATION_EMAIL_SENT'), { email }));
}
